import Link from "next/link";
import React from "react";
import { Container } from "styles/common/container";
import {
  PrivacyPolicyContent,
  PrivacyPolicyContentContainer,
  PrivacyPolicyLanguage,
  PrivacyPolicyLanguageItem,
  PrivacyPolicyPageTitle,
  PrivacyPolicyPageTitleWrapper
} from "styles/pages/kebijakan-privasi.styles";
import { KetentuanLayananSEO } from "seo/kebijakan-privasi.seo";
import KetentuanLayananID from "components/ketentuan-layanan/ketentuan-layanan-id";
import KetentuanLayananEN from "components/ketentuan-layanan/ketentuan-layanan-en";
import { useKebijakanPrivasi } from "hooks/pages/use-kebijakan-privasi/user-kebijakan-privasi";

const KetentuanLayanan: React.FC = () => {
  const { language } = useKebijakanPrivasi();

  return (
    <main>
      <KetentuanLayananSEO />
      <PrivacyPolicyPageTitleWrapper>
        <Container>
          <PrivacyPolicyPageTitle>
            {language === "id"
              ? "Syarat dan Ketentuan"
              : "Terms and Conditions"}
          </PrivacyPolicyPageTitle>
        </Container>
      </PrivacyPolicyPageTitleWrapper>
      <PrivacyPolicyContentContainer>
        <PrivacyPolicyLanguage>
          <Link href="/ketentuan-layanan" passHref>
            <PrivacyPolicyLanguageItem>
              Bahasa Indonesia
            </PrivacyPolicyLanguageItem>
          </Link>
          |
          <Link href="/ketentuan-layanan?lang=en" passHref>
            <PrivacyPolicyLanguageItem>English</PrivacyPolicyLanguageItem>
          </Link>
        </PrivacyPolicyLanguage>

        <PrivacyPolicyContent>
          {language === "id" ? <KetentuanLayananID /> : <KetentuanLayananEN />}
        </PrivacyPolicyContent>
      </PrivacyPolicyContentContainer>
    </main>
  );
};

export default KetentuanLayanan;
